module.exports = __webpack_public_path__ + "assets/img/play.7de1fd28.svg";